// import React, { useState, useEffect } from "react";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import Select from "react-select";
// import { useNavigate } from "react-router-dom";
// import { timetableInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Button from "@mui/material/Button";
// import Box from "@mui/material/Box";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Typography from "@mui/material/Typography";
// import Grid from "@mui/material/Grid";
// import CircularProgress from "@mui/material/CircularProgress";
// import { useParams } from "react-router-dom";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#7451f8",
//     },
//     secondary: {
//       main: "#6c757d",
//     },
//   },
// });

// const dayOptions = [
//   { value: "Monday", label: "Monday" },
//   { value: "Tuesday", label: "Tuesday" },
//   { value: "Wednesday", label: "Wednesday" },
//   { value: "Thursday", label: "Thursday" },
//   { value: "Friday", label: "Friday" },
//   { value: "Saturday", label: "Saturday" },
// ];

// const startTimeOptions = [
//   { value: "15:00", label: "3:00 PM" },
//   { value: "16:00", label: "4:00 PM" },
//   { value: "17:00", label: "5:00 PM" },
//   { value: "18:00", label: "6:00 PM" },
//   { value: "19:00", label: "7:00 PM" },
//   { value: "20:00", label: "8:00 PM" },
//   { value: "21:00", label: "9:00 PM" },
// ];

// const endTimeOptions = [
//   { value: "16:00", label: "4:00 PM" },
//   { value: "17:00", label: "5:00 PM" },
//   { value: "18:00", label: "6:00 PM" },
//   { value: "19:00", label: "7:00 PM" },
//   { value: "20:00", label: "8:00 PM" },
//   { value: "21:00", label: "9:00 PM" },
//   { value: "22:00", label: "10:00 PM" },
// ];

// const TimeTableNew = ({ title }) => {
//   const navigate = useNavigate();
//   const [inputValues, setInputValues] = useState({});
//   const [teacherOptions, setTeacherOptions] = useState([]);
//   const [classOptions, setClassOptions] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([]);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const center_id = localStorage.getItem("center_id");
//   const token = localStorage.getItem("token");
//   const { timeTableMasterId } = useParams();

//   const redirectToLogin = () => {
//     alert("Please login first, then you can access this page...");
//     window.location.href = "/";
//   };

//   useEffect(() => {
//     fetchTeacherNames();
//     fetchSubjectNames();
//     fetchClassNames();
//   }, []);

//   const fetchTeacherNames = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/teacher_ids/${center_id}`);
//       if (!response.ok) throw new Error("Failed to fetch teachers");
//       const data = await response.json();
//       const nameList = data.data.map(({ id, name }) => ({
//         value: id,
//         label: name,
//       }));
//       setTeacherOptions(nameList);
//     } catch (error) {
//       console.error("Error fetching teachers:", error);
//       toast.error("Failed to fetch teacher data");
//     }
//   };

//   const fetchSubjectNames = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) throw new Error("Failed to fetch subjects");
//       const data = await response.json();
//       const nameList = data.data.map(({ id, name }) => ({
//         value: id,
//         label: name,
//       }));
//       setSubjectOptions(nameList);
//     } catch (error) {
//       console.error("Error fetching subjects:", error);
//       toast.error("Failed to fetch subject data");
//     }
//   };

//   const fetchClassNames = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) throw new Error("Failed to fetch classes");
//       const data = await response.json();
//       const nameList = data.data.map(({ id, name }) => ({
//         value: id,
//         label: name,
//       }));
//       setClassOptions(nameList);
//     } catch (error) {
//       console.error("Error fetching classes:", error);
//       toast.error("Failed to fetch class data");
//     }
//   };

//   const handleTeacherSelectChange = async (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       teacher_id: selectedOption.value,
//     });

//     try {
//       const response = await fetch(
//         `${serverUrl}/teacher/user_class_ids/subjects?teacher_id=${selectedOption.value}`
//       );
//       const data = await response.json();

//       const subject = subjectOptions.find(
//         (option) => option.value == data.data.subject_id
//       );
//       const cls = classOptions.find(
//         (option) => option.value === data.data.class_id
//       );

//       setSelectedSubject(subject);
//       setSelectedClass(cls);

//       setInputValues((prev) => ({
//         ...prev,
//         subject_id: subject?.value,
//         class_id: cls?.value,
//       }));
//     } catch (error) {
//       console.error("Error fetching subject and class data:", error);
//       toast.error("Failed to load teacher details");
//     }
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//     setSelectedClass(selectedOption);
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption.value,
//     });
//     setSelectedSubject(selectedOption);
//   };

//   const handleDaySelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       day: selectedOption.value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     if (
//       !inputValues.day ||
//       !inputValues.class_id ||
//       !inputValues.start_slot_time ||
//       !inputValues.end_slot_time
//     ) {
//       toast.error("Please fill all required fields");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const conflictCheckUrl = `${serverUrl}/check_time_slot_conflict?day=${inputValues.day}&class_id=${inputValues.class_id}&start_time=${inputValues.start_slot_time}&end_time=${inputValues.end_slot_time}`;
//       const conflictResponse = await fetch(conflictCheckUrl);
//       const conflictData = await conflictResponse.json();

//       if (conflictData.hasConflict) {
//         toast.error(
//           "This time slot conflicts with an existing class for the same day and class"
//         );
//         setIsLoading(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("center_id", localStorage.getItem("center_id"));
//       formData.append(
//         "timetable_master_id",
//         localStorage.getItem("timetable_master")
//       );
//       formData.append("teacher_id", inputValues.teacher_id);
//       formData.append("class_id", inputValues.class_id);
//       formData.append("subject_id", inputValues.subject_id);
//       formData.append("day", inputValues.day);
//       formData.append("start_slot_time", inputValues.start_slot_time);
//       formData.append("end_slot_time", inputValues.end_slot_time);
//       formData.append("status", inputValues.status || 1);

//       const response = await fetch(`${serverUrl}/add_timetable`, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }
//       } else {
//         toast.success("Time slot added successfully!");
//         setInputValues({});
//         setSelectedSubject(null);
//         setSelectedClass(null);
//         setTimeout(() => {
//           navigate(`/time-table/time-table-slot/${timeTableMasterId}`);
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error("An error occurred while processing your request");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="contentWrapper">
//               <Card className="formCard">
//                 <CardContent className="cardContent">
//                   <Typography
//                     variant="h5"
//                     component="h2"
//                     gutterBottom
//                     className="formTitle"
//                   >
//                     {title}
//                   </Typography>
//                   <form onSubmit={handleSubmit} className="responsiveForm">
//                     <Grid container spacing={2}>
//                       {timetableInputs.map(
//                         (input) =>
//                           input.fieldName !== "status" && (
//                             <Grid
//                               item
//                               xs={12}
//                               sm={6}
//                               key={input.id}
//                               className="formGridItem"
//                             >
//                               <div className="formInput">
//                                 <label>{input.label}</label>
//                                 {input.fieldName === "subject_id" ? (
//                                   <Select
//                                     options={subjectOptions}
//                                     value={selectedSubject}
//                                     onChange={handleSubjectSelectChange}
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: "46px",
//                                         borderColor: "#e2e8f0",
//                                         "&:hover": {
//                                           borderColor: "#cbd5e0",
//                                         },
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: "2px 8px",
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: "0",
//                                         padding: "0",
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: "44px",
//                                       }),
//                                     }}
//                                   />
//                                 ) : input.fieldName === "class_id" ? (
//                                   <Select
//                                     options={classOptions}
//                                     value={selectedClass}
//                                     onChange={handleClassSelectChange}
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: "46px",
//                                         borderColor: "#e2e8f0",
//                                         "&:hover": {
//                                           borderColor: "#cbd5e0",
//                                         },
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: "2px 8px",
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: "0",
//                                         padding: "0",
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: "44px",
//                                       }),
//                                     }}
//                                   />
//                                 ) : input.fieldName === "teacher_id" ? (
//                                   <Select
//                                     options={teacherOptions}
//                                     onChange={handleTeacherSelectChange}
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: "46px",
//                                         borderColor: "#e2e8f0",
//                                         "&:hover": {
//                                           borderColor: "#cbd5e0",
//                                         },
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: "2px 8px",
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: "0",
//                                         padding: "0",
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: "44px",
//                                       }),
//                                     }}
//                                   />
//                                 ) : input.fieldName === "day" ? (
//                                   <Select
//                                     options={dayOptions}
//                                     onChange={handleDaySelectChange}
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: "46px",
//                                         borderColor: "#e2e8f0",
//                                         "&:hover": {
//                                           borderColor: "#cbd5e0",
//                                         },
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: "2px 8px",
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: "0",
//                                         padding: "0",
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: "44px",
//                                       }),
//                                     }}
//                                   />
//                                 ) : input.fieldName === "start_slot_time" ? (
//                                   <Select
//                                     options={startTimeOptions}
//                                     onChange={(selectedOption) =>
//                                       setInputValues({
//                                         ...inputValues,
//                                         start_slot_time: selectedOption.value,
//                                       })
//                                     }
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: "46px",
//                                         borderColor: "#e2e8f0",
//                                         "&:hover": {
//                                           borderColor: "#cbd5e0",
//                                         },
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: "2px 8px",
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: "0",
//                                         padding: "0",
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: "44px",
//                                       }),
//                                     }}
//                                   />
//                                 ) : input.fieldName === "end_slot_time" ? (
//                                   <Select
//                                     options={endTimeOptions}
//                                     onChange={(selectedOption) =>
//                                       setInputValues({
//                                         ...inputValues,
//                                         end_slot_time: selectedOption.value,
//                                       })
//                                     }
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: "46px",
//                                         borderColor: "#e2e8f0",
//                                         "&:hover": {
//                                           borderColor: "#cbd5e0",
//                                         },
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: "2px 8px",
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: "0",
//                                         padding: "0",
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: "44px",
//                                       }),
//                                     }}
//                                   />
//                                 ) : (
//                                   <input
//                                     type={input.type}
//                                     placeholder={input.placeholder}
//                                     name={input.fieldName}
//                                     value={inputValues[input.fieldName] || ""}
//                                     onChange={handleInputChange}
//                                     required={input.fieldName !== "status"}
//                                   />
//                                 )}
//                               </div>
//                             </Grid>
//                           )
//                       )}
//                     </Grid>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: 3,
//                         mt: 4,
//                         pb: 2,
//                       }}
//                     >
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() =>
//                           navigate(
//                             `/time-table/time-table-slot/${timeTableMasterId}`
//                           )
//                         }
//                         sx={{ minWidth: "120px", height: "42px" }}
//                       >
//                         Cancel
//                       </Button>
//                       <Button
//                         type="submit"
//                         variant="contained"
//                         color="primary"
//                         disabled={isLoading}
//                         sx={{ minWidth: "150px", height: "42px" }}
//                         startIcon={
//                           isLoading ? (
//                             <CircularProgress size={20} color="inherit" />
//                           ) : null
//                         }
//                       >
//                         {isLoading ? "Processing..." : "Create Slot"}
//                       </Button>
//                     </Box>
//                   </form>
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </ThemeProvider>
//   );
// };

// export default TimeTableNew;
import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { timetableInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const dayOptions = [
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
];

const startTimeOptions = [
  { value: "15:00", label: "3:00 PM" },
  { value: "16:00", label: "4:00 PM" },
  { value: "17:00", label: "5:00 PM" },
  { value: "18:00", label: "6:00 PM" },
  { value: "19:00", label: "7:00 PM" },
  { value: "20:00", label: "8:00 PM" },
  { value: "21:00", label: "9:00 PM" },
];

const endTimeOptions = [
  { value: "16:00", label: "4:00 PM" },
  { value: "17:00", label: "5:00 PM" },
  { value: "18:00", label: "6:00 PM" },
  { value: "19:00", label: "7:00 PM" },
  { value: "20:00", label: "8:00 PM" },
  { value: "21:00", label: "9:00 PM" },
  { value: "22:00", label: "10:00 PM" },
];

const TimeTableNew = ({ title }) => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({
    is_assessment: 0,
  });
  const [teacherOptions, setTeacherOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);

  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAssessment, setIsAssessment] = useState(false);
  const center_id = localStorage.getItem("center_id");
  const token = localStorage.getItem("token");
  const { timeTableMasterId } = useParams();

  const redirectToLogin = () => {
    alert("Please login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    fetchTeacherNames();
    fetchSubjectNames();
  }, []);

  useEffect(() => {
    if (isAssessment) {
      // Clear teacher and subject when it's an assessment
      setSelectedTeacher(null);
      setSelectedSubject(null);
      setInputValues((prev) => ({
        ...prev,
        teacher_id: null,
        subject_id: null,
      }));
    }
  }, [isAssessment]);

  const fetchTeacherNames = async () => {
    try {
      const response = await fetch(
        `${serverUrl}/teacher_ids_by_class/${localStorage.getItem(
          "timetable_master_class_id"
        )}`
      );
      if (!response.ok) throw new Error("Failed to fetch teachers");
      const data = await response.json();
      const nameList = data.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setTeacherOptions(nameList);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      toast.error("Failed to fetch teacher data");
    }
  };

  const fetchSubjectNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch subjects");
      const data = await response.json();
      const nameList = data.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setSubjectOptions(nameList);
    } catch (error) {
      console.error("Error fetching subjects:", error);
      toast.error("Failed to fetch subject data");
    }
  };

  const handleTeacherSelectChange = async (selectedOption) => {
    setSelectedTeacher(selectedOption);
    setInputValues({
      ...inputValues,
      teacher_id: selectedOption.value,
    });

    try {
      const response = await fetch(
        `${serverUrl}/teacher/user_class_ids/subjects?teacher_id=${selectedOption.value}`
      );
      const data = await response.json();

      const subject = subjectOptions.find(
        (option) => option.value == data.data.subject_id
      );

      setSelectedSubject(subject);

      setInputValues((prev) => ({
        ...prev,
        subject_id: subject?.value,
      }));
    } catch (error) {
      console.error("Error fetching subject and class data:", error);
      toast.error("Failed to load teacher details");
    }
  };

  const handleSubjectSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      subject_id: selectedOption.value,
    });
    setSelectedSubject(selectedOption);
  };

  const handleDaySelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      day: selectedOption.value,
    });
  };

  const handleAssessmentChange = (e) => {
    const isChecked = e.target.checked;
    setIsAssessment(isChecked);
    setInputValues({
      ...inputValues,
      is_assessment: isChecked ? 1 : 0,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Basic required fields for all entries
    if (
      !inputValues.day ||
      !inputValues.start_slot_time ||
      !inputValues.end_slot_time
    ) {
      toast.error("Please fill all required fields");
      setIsLoading(false);
      return;
    }

    // For non-assessment entries, validate teacher and subject
    if (!isAssessment) {
      if (!inputValues.teacher_id || !inputValues.subject_id) {
        toast.error(
          "Teacher and Subject are required for non-assessment entries"
        );
        setIsLoading(false);
        return;
      }
    }

    // Rest of your existing code remains the same...
    try {
      const conflictCheckUrl = `${serverUrl}/check_time_slot_conflict?day=${
        inputValues.day
      }&class_id=${localStorage.getItem(
        "timetable_master_class_id"
      )}&start_time=${inputValues.start_slot_time}&end_time=${
        inputValues.end_slot_time
      }`;
      const conflictResponse = await fetch(conflictCheckUrl);
      const conflictData = await conflictResponse.json();

      if (conflictData.hasConflict) {
        toast.error(
          "This time slot conflicts with an existing class for the same day and class"
        );
        setIsLoading(false);
        return;
      }

      // For non-assessment entries only, check teacher conflict
      if (!isAssessment && inputValues.teacher_id) {
        const teacherConflictUrl = `${serverUrl}/check_teacher_conflict?day=${inputValues.day}&teacher_id=${inputValues.teacher_id}&start_time=${inputValues.start_slot_time}&end_time=${inputValues.end_slot_time}`;
        const teacherConflictResponse = await fetch(teacherConflictUrl);
        const teacherConflictData = await teacherConflictResponse.json();

        if (teacherConflictData.hasConflict) {
          toast.error("Teacher already has a class scheduled during this time");
          setIsLoading(false);
          return;
        }
      }

      const formData = new FormData();
      formData.append("center_id", localStorage.getItem("center_id"));
      formData.append(
        "timetable_master_id",
        localStorage.getItem("timetable_master")
      );
      formData.append("teacher_id", inputValues.teacher_id || "");
      formData.append(
        "class_id",
        localStorage.getItem("timetable_master_class_id")
      );
      formData.append("subject_id", inputValues.subject_id || "");
      formData.append("is_assessment", inputValues.is_assessment);
      formData.append("day", inputValues.day);
      formData.append("start_slot_time", inputValues.start_slot_time);
      formData.append("end_slot_time", inputValues.end_slot_time);
      formData.append("status", inputValues.status || 1);

      const response = await fetch(`${serverUrl}/add_timetable`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Time slot added successfully!");
        setInputValues({ is_assessment: 0 });
        setIsAssessment(false);
        setSelectedSubject(null);
        setSelectedTeacher(null);
        setTimeout(() => {
          navigate(`/time-table/time-table-slot/${timeTableMasterId}`);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred while processing your request");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {/* Assessment Checkbox */}
                      <Grid item xs={12}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isAssessment}
                                onChange={handleAssessmentChange}
                                name="is_assessment"
                                color="primary"
                              />
                            }
                            label="This is an assessment slot (Teacher and Subject will be disabled)"
                          />
                        </FormGroup>
                      </Grid>

                      {timetableInputs.map(
                        (input) =>
                          input.fieldName !== "status" && (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              key={input.id}
                              className="formGridItem"
                            >
                              <div className="formInput">
                                <label>{input.label}</label>
                                {input.fieldName === "subject_id" ? (
                                  <Select
                                    options={subjectOptions}
                                    value={selectedSubject}
                                    onChange={handleSubjectSelectChange}
                                    required={!isAssessment}
                                    isDisabled={isAssessment}
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "46px",
                                        borderColor: "#e2e8f0",
                                        "&:hover": {
                                          borderColor: "#cbd5e0",
                                        },
                                        backgroundColor: isAssessment
                                          ? "#f5f5f5"
                                          : "white",
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: "2px 8px",
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: "0",
                                        padding: "0",
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "44px",
                                      }),
                                    }}
                                  />
                                ) : input.fieldName === "teacher_id" ? (
                                  <Select
                                    options={teacherOptions}
                                    value={selectedTeacher}
                                    onChange={handleTeacherSelectChange}
                                    required={!isAssessment}
                                    isDisabled={isAssessment}
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "46px",
                                        borderColor: "#e2e8f0",
                                        "&:hover": {
                                          borderColor: "#cbd5e0",
                                        },
                                        backgroundColor: isAssessment
                                          ? "#f5f5f5"
                                          : "white",
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: "2px 8px",
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: "0",
                                        padding: "0",
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "44px",
                                      }),
                                    }}
                                  />
                                ) : input.fieldName === "day" ? (
                                  <Select
                                    options={dayOptions}
                                    onChange={handleDaySelectChange}
                                    required
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "46px",
                                        borderColor: "#e2e8f0",
                                        "&:hover": {
                                          borderColor: "#cbd5e0",
                                        },
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: "2px 8px",
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: "0",
                                        padding: "0",
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "44px",
                                      }),
                                    }}
                                  />
                                ) : input.fieldName === "start_slot_time" ? (
                                  <Select
                                    options={startTimeOptions}
                                    onChange={(selectedOption) =>
                                      setInputValues({
                                        ...inputValues,
                                        start_slot_time: selectedOption.value,
                                      })
                                    }
                                    required
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "46px",
                                        borderColor: "#e2e8f0",
                                        "&:hover": {
                                          borderColor: "#cbd5e0",
                                        },
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: "2px 8px",
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: "0",
                                        padding: "0",
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "44px",
                                      }),
                                    }}
                                  />
                                ) : input.fieldName === "end_slot_time" ? (
                                  <Select
                                    options={endTimeOptions}
                                    onChange={(selectedOption) =>
                                      setInputValues({
                                        ...inputValues,
                                        end_slot_time: selectedOption.value,
                                      })
                                    }
                                    required
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "46px",
                                        borderColor: "#e2e8f0",
                                        "&:hover": {
                                          borderColor: "#cbd5e0",
                                        },
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: "2px 8px",
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: "0",
                                        padding: "0",
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "44px",
                                      }),
                                    }}
                                  />
                                ) : (
                                  <input
                                    type={input.type}
                                    placeholder={input.placeholder}
                                    name={input.fieldName}
                                    value={inputValues[input.fieldName] || ""}
                                    onChange={handleInputChange}
                                    required={input.fieldName !== "status"}
                                  />
                                )}
                              </div>
                            </Grid>
                          )
                      )}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() =>
                          navigate(
                            `/time-table/time-table-slot/${timeTableMasterId}`
                          )
                        }
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isLoading}
                        sx={{ minWidth: "150px", height: "42px" }}
                        startIcon={
                          isLoading ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : null
                        }
                      >
                        {isLoading ? "Processing..." : "Create Slot"}
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default TimeTableNew;
